// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: n-4lHKu1-Xdt
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicMilestoneBody.module.css"; // plasmic-import: n-4lHKu1-Xdt/css

createPlasmicElementProxy;

export const PlasmicMilestoneBody__VariantProps = new Array();

export const PlasmicMilestoneBody__ArgProps = new Array();

const $$ = {};

function PlasmicMilestoneBody__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__kGXqG
        )}
      >
        {"Milestone Name"}
      </div>
      <input
        data-plasmic-name={"name"}
        data-plasmic-override={overrides.name}
        className={classNames(projectcss.all, projectcss.input, sty.name)}
        placeholder={"Milestone Name"}
        ref={ref => {
          $refs["name"] = ref;
        }}
        size={1}
        type={"text"}
        value={""}
      />

      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__roQvq
        )}
      >
        {"Amount"}
      </div>
      <div
        data-plasmic-name={"amount"}
        data-plasmic-override={overrides.amount}
        className={classNames(projectcss.all, sty.amount)}
      />

      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__jeTjN
        )}
      >
        {"Payment Due Date (optional)"}
      </div>
      <div
        data-plasmic-name={"dueDate"}
        data-plasmic-override={overrides.dueDate}
        className={classNames(projectcss.all, sty.dueDate)}
      />

      <div
        className={classNames(
          projectcss.all,
          projectcss.__wab_text,
          sty.text__aPaSb
        )}
      >
        {"Description (optional)"}
      </div>
      <textarea
        data-plasmic-name={"description"}
        data-plasmic-override={overrides.description}
        className={classNames(
          projectcss.all,
          projectcss.textarea,
          sty.description
        )}
        placeholder={""}
        ref={ref => {
          $refs["description"] = ref;
        }}
        value={""}
      />
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "name", "amount", "dueDate", "description"],
  name: ["name"],
  amount: ["amount"],
  dueDate: ["dueDate"],
  description: ["description"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicMilestoneBody__ArgProps,
          internalVariantPropNames: PlasmicMilestoneBody__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicMilestoneBody__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicMilestoneBody";
  } else {
    func.displayName = `PlasmicMilestoneBody.${nodeName}`;
  }
  return func;
}

export const PlasmicMilestoneBody = Object.assign(
  // Top-level PlasmicMilestoneBody renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    _name: makeNodeComponent("name"),
    amount: makeNodeComponent("amount"),
    dueDate: makeNodeComponent("dueDate"),
    description: makeNodeComponent("description"),
    // Metadata about props expected for PlasmicMilestoneBody
    internalVariantProps: PlasmicMilestoneBody__VariantProps,
    internalArgProps: PlasmicMilestoneBody__ArgProps
  }
);

export default PlasmicMilestoneBody;
/* prettier-ignore-end */
